/**
 * Tabbed Content Section JavaScript
 * Handles tab switching functionality
 */

class TabbedContent {
  constructor(section) {
    this.section = section;
    this.tabs = section.querySelectorAll('.tabbed-content__tab');
    this.panels = section.querySelectorAll('.tabbed-content__panel');
    
    this.init();
  }

  init() {
    // Add click event listeners to tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(index);
      });

      // Keyboard navigation
      tab.addEventListener('keydown', (e) => {
        this.handleKeyboard(e, index);
      });
    });
  }

  switchTab(targetIndex) {
    // Deactivate all tabs and panels
    this.tabs.forEach((tab, index) => {
      const panel = this.panels[index];
      const isTarget = index === targetIndex;

      tab.classList.toggle('is-active', isTarget);
      tab.setAttribute('aria-selected', isTarget);
      
      if (panel) {
        panel.classList.toggle('is-active', isTarget);
        panel.hidden = !isTarget;
      }
    });
  }

  handleKeyboard(e, currentIndex) {
    let targetIndex = currentIndex;

    // Arrow key navigation
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        targetIndex = currentIndex > 0 ? currentIndex - 1 : this.tabs.length - 1;
        break;
      case 'ArrowRight':
        e.preventDefault();
        targetIndex = currentIndex < this.tabs.length - 1 ? currentIndex + 1 : 0;
        break;
      case 'Home':
        e.preventDefault();
        targetIndex = 0;
        break;
      case 'End':
        e.preventDefault();
        targetIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    // Switch to target tab and focus
    this.switchTab(targetIndex);
    this.tabs[targetIndex].focus();
  }
}

// Initialize all tabbed content sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section-tabbed-content');
  sections.forEach(section => {
    new TabbedContent(section);
  });
});

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.section-tabbed-content');
    if (section) {
      new TabbedContent(section);
    }
  });
}
